import { useEffect, useRef, useState } from 'react'
import { SDrawerOrModal, SLowcodeList, STitle } from 'shj-components'
import { Form, Select, DatePicker, Row, Col, Button } from 'antd'
import dayjs from 'dayjs'
import {
  productSearchList,
  getSkuCombinationInfo,
  priceCalculatePriceCalculate,
} from '@/services/product'
import ChooseCombinateSkuModal from '@/components/ChooseCombinateSkuModal'
import { config } from './config'
import { sonConfig } from './sonConfig'
import ConstructionCostModal from '../constructionCostModal'
import { isEmpty } from 'lodash-es'

export default function CombinatePriceModal({
  open = false,
  setOpen = (status: boolean) => ({}),
  skuId = '',
  orgList = [],
}) {
  const [formRef] = Form.useForm()
  const listRef = useRef<any>(null)
  const listRef2 = useRef<any>(null)
  const [loading, setLoading] = useState(false)
  const [productList, setProductList] = useState([])
  const [openCombinationSkuModal, setOpenCombinationSkuModal] = useState(false)
  const [skuInfo, setSkuInfo] = useState({})
  const [combinationInfoList, setCombinationInfoList] = useState([])
  const [constructionCostModalOpen, setConstructionCostModalOpen] = useState(false)
  const [constructionCostModalRecord, setConstructionCostModalRecord] = useState<any>(null)

  useEffect(() => {
    getOption()
  }, [])

  const getOption = async () => {
    const skuRes: any = await getSkuCombinationInfo({
      id: skuId,
      queryCombinationInfoDetail: true,
    })
    skuRes?.combinationInfo?.forEach(item => (item.checked = true)) // 可选项默认选中
    setSkuInfo(skuRes)
    const defaultCombinationList = skuRes?.combinationInfo?.map(item => ({
      ...item,
      selectSkuId: item?.selectedSkuList?.[0]?.id,
      selectArgList: Object.keys(item?.selectedSkuList?.[0]?.argMap)?.map((code: any) => ({
        argCode: code,
        argType: item?.selectedSkuList?.[0]?.argMap?.[code]?.argType,
        argVal: item?.selectedSkuList?.[0]?.argMap?.[code]?.valueId,
        argValCode: item?.selectedSkuList?.[0]?.argMap?.[code]?.valueCode,
      })),
    }))
    setCombinationInfoList(defaultCombinationList)
    const res: any = await productSearchList({
      prodType: 'PRODUCT_PACKAGE',
      enabled: true,
    })
    if (Array.isArray(res)) {
      setProductList(res)
      formRef.setFieldsValue({
        currentDate: dayjs(),
        productId: res[0]?.id,
        companyId: orgList?.[0]?.id,
      })
      onSearch(defaultCombinationList)
    }
  }

  const onClose = () => {
    setOpen(false)
  }

  const onSearch = (list: Array<any>) => {
    formRef.validateFields().then(async values => {
      setLoading(true)
      const data = {
        productId: values.productId,
        currentDate: dayjs(values.currentDate).valueOf(),
        companyId: values.companyId,
        details: [
          {
            identityId: skuId,
            type: 'SKU',
            skuId,
            children: list
              ?.filter(item => item.checked)
              ?.map((com: any) => ({
                identityId: com.selectSkuId,
                type: 'SKU',
                skuId: com.selectSkuId,
              })),
          },
        ],
      }
      try {
        const res: any = await priceCalculatePriceCalculate({
          data,
        })
        if (Array.isArray(res)) {
          const mainList = res?.filter(item => item.skuId === skuId)
          const noMainList = res?.filter(item => item.skuId !== skuId)
          listRef.current?.updateDataSource(mainList, mainList.length)
          listRef2.current?.updateDataSource(noMainList, noMainList.length)
        }
        setLoading(false)
      } catch (err) {
        setLoading(false)
      }
    })
  }

  const handleOpenSkuModal = () => {
    setOpenCombinationSkuModal(true)
  }
  const clickToShowConstructionCostModal = (record: Record<string, any>) => () => {
    record.effectiveDate = dayjs(formRef?.getFieldValue('currentDate'))?.valueOf()
    record.productId = formRef?.getFieldValue('productId')
    record.companyId = formRef?.getFieldValue('companyId')
    setConstructionCostModalOpen(true)
    setConstructionCostModalRecord(record)
  }
  const renderNode = {
    customRender: {
      actionRender(_, record: Record<string, any>) {
        if (record.constructionPriceInfo && !isEmpty(record.constructionPriceInfo)) {
          return (
            <Button type="link" onClick={clickToShowConstructionCostModal(record)}>
              施工成本构成
            </Button>
          )
        }
      },
    },
  }
  return (
    <div>
      <SDrawerOrModal
        mode="drawer"
        open={open}
        onCancel={() => onClose()}
        antdProps={{
          footer: null,
        }}
        loading={loading}
        width={1000}
        title={'查看价格'}
      >
        <Form form={formRef}>
          <Row gutter={[20, 10]}>
            <Col span={6}>
              <Form.Item label={'适用产品'} name={'productId'} rules={[{ required: true }]}>
                <Select
                  options={productList}
                  showSearch
                  optionFilterProp={'prodName'}
                  fieldNames={{ label: 'prodName', value: 'id' }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label={'适用门店'} name={'companyId'} rules={[{ required: true }]}>
                <Select
                  options={orgList}
                  showSearch
                  optionFilterProp={'companyName'}
                  fieldNames={{ label: 'companyName', value: 'orgId' }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="日期" name="currentDate" rules={[{ required: true }]}>
                <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} allowClear />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Button type="primary" onClick={handleOpenSkuModal}>
                切换产品明细
              </Button>
            </Col>
            <Col span={3}>
              <Button type="primary" onClick={() => onSearch(combinationInfoList)}>
                查询
              </Button>
            </Col>
          </Row>
        </Form>
        <STitle title={'主数据'} />
        <SLowcodeList ref={listRef} searchMode="group" config={config} />
        <STitle title={'子数据'} />
        <SLowcodeList ref={listRef2} searchMode="group" config={sonConfig} {...renderNode} />
      </SDrawerOrModal>
      {openCombinationSkuModal && (
        <ChooseCombinateSkuModal
          open={openCombinationSkuModal}
          closeDialog={() => setOpenCombinationSkuModal(false)}
          productInfo={skuInfo}
          combinationInfoList={combinationInfoList}
          confirmInfo={(list: any) => {
            setCombinationInfoList(list)
            setSkuInfo({ ...skuInfo, combinationInfo: list })
            onSearch(list)
          }}
        />
      )}
      {constructionCostModalOpen && (
        <ConstructionCostModal
          open={constructionCostModalOpen}
          record={constructionCostModalRecord}
          onClose={() => setConstructionCostModalOpen(false)}
        ></ConstructionCostModal>
      )}
    </div>
  )
}
